module.exports = __webpack_public_path__ + "img/组 497@2x.9f56b294.png";